import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';


function Login(props) {
    const { login, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const from = location.state?.from?.pathname || '/dashboard';

    React.useEffect(() => {
        if (isAuthenticated) {
            navigate(from, { replace: true });
        }
    }, [isAuthenticated, navigate, from]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        const result = login(email, password);
        
        if (result.success) {
            navigate(from, { replace: true });
        } else {
            setError(result.error);
        }
    };

    return (
        <div>

<section className="tf-page-title style-2">    
                <div className="tf-container">
                    <div className="row">
                        <div className="col-md-12">

                            <ul className="breadcrumbs">
                                <li><Link to="/">Home</Link></li>
                                <li>Login</li>
                            </ul>
                   
                        </div>
                    </div>
                </div>                    
            </section>
                
            <section className="tf-login">
                <div className="tf-container">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <div className="tf-heading style-5">
                                <h4 className="heading">Login to Your Account</h4>
                                <p className="sub-heading">Access your voucher vault and manage your digital vouchers securely.</p>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-8 col-md-12">
                            
                            <form onSubmit={handleSubmit} id="contactform">
                                <div className="title-login">Login with your credentials</div>
                                
                                {error && (
                                    <div style={{
                                        padding: '15px',
                                        marginBottom: '20px',
                                        background: '#fee',
                                        border: '1px solid #fcc',
                                        borderRadius: '8px',
                                        color: '#c33'
                                    }}>
                                        {error}
                                    </div>
                                )}

                                <div style={{
                                    padding: '15px',
                                    marginBottom: '20px',
                                    background: '#e3f2fd',
                                    border: '1px solid #90caf9',
                                    borderRadius: '8px',
                                    fontSize: '14px'
                                }}>
                                    <strong>Test Credentials:</strong><br/>
                                    Email: test@dtwallet.com<br/>
                                    Password: test123
                                </div>

                                <fieldset>
                                    <input 
                                        id="email" 
                                        name="email" 
                                        tabIndex="1" 
                                        aria-required="true" 
                                        required 
                                        type="email" 
                                        placeholder="Email Address" 
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </fieldset>
                               <fieldset className="mb24"> 
                                    <input 
                                        id="showpassword" 
                                        name="password" 
                                        tabIndex="2" 
                                        aria-required="true"  
                                        type={showPassword ? "text" : "password"} 
                                        placeholder="Password" 
                                        required 
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <span 
                                        className="btn-show-pass" 
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{cursor: 'pointer'}}
                                    >
                                        <i className={showPassword ? "far fa-eye" : "far fa-eye-slash"}></i>
                                    </span>
                                </fieldset>
                                <div className="forgot-pass-wrap">
                                    <label>Remember me
                                        <input type="checkbox" />
                                        <span className="btn-checkbox"></span>
                                    </label>
                                </div>
                                <button 
                                    className="submit" 
                                    type="submit"
                                    style={{
                                        background: '#FFC107',
                                        color: '#000',
                                        border: 'none',
                                        fontWeight: '600'
                                    }}
                                >
                                    Login
                                </button>
                                <div style={{textAlign: 'center', marginTop: '20px'}}>
                                    <p>Don't have an account? <Link to="/signup" style={{color: '#FFC107', fontWeight: '600'}}>Sign Up</Link></p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            
        </div>
    );
}

export default Login;